// src/pages/SheEarnsHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const SheEarnsHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Digital Income", emoji: "💰" },
    { label: "Digital Learning", emoji: "💡" },
    { label: "Smarty", emoji: "🤓" },
    { label: "Task & Management", emoji: "🗂️" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Shakti Shopping", emoji: "🛍️" },
    { label: "CareWorld", emoji: "💚" },
    { label: "Community & Social", emoji: "🤝" },
    { label: "Recognition & Progress", emoji: "🏅" },
    { label: "Analytics & Insights", emoji: "📊" },
    { label: "Wishes & Fun", emoji: "🎬" },
    { label: "MahilaMandi", emoji: "🔆" },
    { label: "GaonSe", emoji: "🏡" },
    { label: "SAKSHAM SHG", emoji: "🌟" },
    { label: "SHG", emoji: "🪙" },          
    { label: "Maharashtra Rozgar Hami", emoji: "🛠️" },
    { label: "Santulit Buy", emoji: "🛒" },    
    { label: "Kahani Aaj Ki", emoji: "🎧" }, 
  ];

  const menuButtons1 = [
    // 💡 DIGITAL LEARNING
    { label: "My Immersive Digital Books", emoji: "📚", link: "/bookshelf", group: "Digital Learning" },
    { label: "Shakti Digital Books", emoji: "📖", link: "/sheearns-bookworld", group: "Digital Learning" },
    { label: "Shakti Shorts", emoji: "🎬", link: "/litenshort", group: "Digital Learning" },
    { label: "Shakti Workshops", emoji: "🎓", link: "/sheearns-trainingworkshop", group: "Digital Learning" },
    { label: "Shakti Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Digital Learning" },

    // 💰 DIGITAL INCOME
    { label: "ValueShare", emoji: "💱", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "My Income", emoji: "💰", link: "/sheearns-income", group: "Digital Income" },
    { label: "Introduce User", emoji: "👥📢", link: "/sheearns-introduce", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️💻", link: "/digiboutique", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🛒🎁", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Marksheet Contest", emoji: "📜🏆", link: "/applause-marksheet-contest", group: "Digital Income" },
    { label: "Rewarding Cooking", emoji: "🍳💰", link: "/sheearns-rewardingcooking", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "📺💎", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥💰", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Business Funding", emoji: "💼💳", link: "/fundlanes", group: "Digital Income" },

    // 🗂️ Smarty
    { label: "Smarty", emoji: "📝", link: "/smarty", group: "Smarty" },

    // 🗂️ TASK & MANAGEMENT
    { label: "Shakti Daily", emoji: "📝", link: "/sheearns-daily", group: "Task & Management" },
    { label: "Diary", emoji: "📔", link: "/mydiary-home", group: "Task & Management" },
    { label: "Health & Wellness", emoji: "💚", link: "/sheearns-health", group: "Task & Management" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Task & Management" },
    { label: "Goal Board", emoji: "🎯", link: "/sheearns-goalboard", group: "Task & Management" },
    { label: "Kanban", emoji: "📊", link: "/sheearns-kanban", group: "Task & Management" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/sheearns-touchbookplain", group: "Task & Management" },
    { label: "Digital Writing Grid", emoji: "✍️📊", link: "/sheearns-touchbookgrid", group: "Task & Management" },
    { label: "Digital Voice Writing", emoji: "🎙️✍️", link: "/sheearns-voicebook", group: "Task & Management" },
    { label: "Tindi", emoji: "🚗🚌🚆", link: "/tindi", group: "Task & Management" },

    // 🛍️ SHAKTI SHOPPING
    { label: "My Orders", emoji: "📦", link: "/myprofile-myorders", group: "Shakti Shopping" },
    { label: "Home Basket", emoji: "🏡🛒", link: "/createmyvegbasket", group: "Shakti Shopping" },
    { label: "Mahila Mandi Basket", emoji: "🛒🏡", link: "/catalogue/mahilamandi", group: "Shakti Shopping" },
    { label: "Personal Shopping", emoji: "👜💃", link: "/orderflow-home", group: "Shakti Shopping" },
    { label: "Family Shopping", emoji: "👨‍👩‍👧‍👦🛒", link: "/orderflow-home", group: "Shakti Shopping" },
    { label: "GaonSe", emoji: "👨‍👩‍👧‍👦🛒", link: "/gaonse", group: "Shakti Shopping" },
    { label: "MahilaMandi Nearby Deals", emoji: "📍🛍️", link: "/mahilamandi-nearbydeals", group: "Shakti Shopping" },
    { label: "Juhi", emoji: "🌸💅", link: "/juhi", group: "Shakti Shopping" },
    { label: "Bhojan", emoji: "🍱🍛", link: "/bhojan", group: "Shakti Shopping" },
    { label: "Ratnavya", emoji: "💎✨", link: "/ratnavya", group: "Shakti Shopping" },
    { label: "Gift", emoji: "🎁💖", link: "/giftify", group: "Shakti Shopping" },
    { label: "RoomAnywhere", emoji: "🏠🌍", link: "/roomanywhere", group: "Shakti Shopping" },
    { label: "ThinkStylus", emoji: "🖊️💡", link: "/thinkstylus", group: "Shakti Shopping" },
    { label: "MADSmania", emoji: "📄🔁🎨", link: "/madsmania-home", group: "Shakti Shopping" },
    { label: "DSeven", emoji: "🧩7️⃣🌈", link: "/dseven", group: "Shakti Shopping" },
    { label: "Digital Tryout", emoji: "🪄💻", link: "/digitaltryout", group: "Shakti Shopping" },
    { label: "Window Shopping", emoji: "🏬👀", link: "/twiworld", group: "Shakti Shopping" },

    // 🌸 MahilaMandi
    { label: "I Have Product to Sell", emoji: "🙋‍♀️🧵", link: "/mlmproductrequest/add", group: "MahilaMandi" },
    { label: "GaonSe", emoji: "👨‍👩‍👧‍👦🛒", link: "/gaonse", group: "MahilaMandi" },
    { label: "Everyhome Hunar Mandi", emoji: "🏠🎨", link: "/catalogue/hunar", group: "MahilaMandi" },
    { label: "AdiShakti Mandi (Tribal)", emoji: "🌿🪶", link: "/catalogue/tribal", group: "MahilaMandi" },
    { label: "Grandma’s Shakti Mandi", emoji: "👵🍪", link: "catalogue/gramin", group: "MahilaMandi" },
    { label: "Divyaang Shakti Mandi", emoji: "♿🌈", link: "/catalogue/divyang", group: "MahilaMandi" },
    { label: "New Hunar Mandi", emoji: "🆕🪡", link: "/catalogue/shakinew", group: "MahilaMandi" },
    { label: "MahilaMandi Basket", emoji: "🧺🤝", link: "/mahilamandi-createbasket", group: "MahilaMandi" },
    { label: "MahilaMandi Padoss", emoji: "📍🏘️", link: "/mahilamandi-nearbydeals", group: "MahilaMandi" },
    { label: "Export Desk", emoji: "🚢🌏", link: "/mahilamandi-exportimport", group: "MahilaMandi" },
    { label: "Packaging Market", emoji: "📦🎁", link: "/mahilamandi-packaging", group: "MahilaMandi" },
    { label: "Contract Manufacturing", emoji: "🤝🏭", link: "/mahilamandi-contractmfg", group: "MahilaMandi" },
    { label: "Unity Deals", emoji: "🛒🤗", link: "/mahilamandi-unitydeals", group: "MahilaMandi" },
    { label: "Quick Delivery", emoji: "⚡🚚", link: "/mahilamandi-xpresshome", group: "MahilaMandi" },
    { label: "Wholesale by MahilaMandi", emoji: "🚜📦", link: "/mahilamandi-wholesale", group: "MahilaMandi" },
    { label: "Material Wholesale Price", emoji: "🏪📊", link: "/mahilamandi-wholesalesupply", group: "MahilaMandi" },
    { label: "View Material Live", emoji: "🏬👀", link: "/twiworld", group: "MahilaMandi" },
    { label: "Mahila Grih Seva", emoji: "🏠🤲👩‍🍳", link: "/digiboutique", group: "MahilaMandi" },
    { label: "Enquiry", emoji: "📩❓", link: "/mahilamandi-leads", group: "MahilaMandi" },
    { label: "Complaints", emoji: "⚠️📢", link: "/mahilamandi-complaints", group: "MahilaMandi" },
    { label: "Digital Boutique Rozgar", emoji: "💻💪👩‍💼", link: "/digiboutique", group: "MahilaMandi" },
    { label: "Meet The Maker", emoji: "🤝👩‍🎨", link: "/meetthemaker", group: "MahilaMandi" },
    { label: "Support A Maker", emoji: "❤️🛍️", link: "/supportamaker", group: "MahilaMandi" },
    { label: "SAKSHAM Shakti Impact", emoji: "⚡🌸🇮🇳", link: "/sakshamshakti-impact", group: "MahilaMandi" },
    { label: "MahilaMandi Weekly", emoji: "📰", link: "/mahilamandi-weekly", group: "MahilaMandi" },
    { label: "MahilaMandi Logistics", emoji: "🚛", link: "/mahilamandi-logistic", group: "MahilaMandi" },
    { label: "Management", emoji: "📋", link: "/shgmanagement", group: "MahilaMandi" },

    // 🪞 SHELF REFLECTION
    { label: "My Pink Card", emoji: "💖", link: "/digitalshakticard", group: "Self Reflection" },
    { label: "My Memories", emoji: "📸", link: "/memories-list", group: "Self Reflection" },
    { label: "Grihani", emoji: "🏡", link: "/grihani", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/sheearns-focustimerstart", group: "Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Self Reflection" },
    { label: "Shakti AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Self Reflection" },
    { label: "Motherhood Journey", emoji: "🤱", link: "/sheearns-motherhood", group: "Self Reflection" },
    { label: "Personal Lifestages", emoji: "🌱", link: "/myprofile-lifestages", group: "Self Reflection" },  
    { label: "Pre-Schooler MATRIKA", emoji: "👩‍👩‍👧", link: "/matrika", group: "Self Reflection" },
    { label: "My Jugaad / Hack", emoji: "🧱", link: "/jugaad", group: "Self Reflection" },
    { label: "My Think5Whys Profile", emoji: "🧱", link: "/sheearns-profilehome", group: "Self Reflection" },

    // 🪙 Swayam Sahayata
    { label: "My SHG", emoji: "📝👥", link: "/myshg", group: "SHG" },
    { label: "Register", emoji: "📢", state: "All", link: "/shgregister", group: "SHG" },
    { label: "Andra Pradesh మహిళా స్వయం సహాయక బృందం", emoji: "💃🌾", state: "Andhra Pradesh", link: "/shg", group: "SHG"  },
    { label: "Assam মহিলা স্বনির্ভৰ গোট", emoji: "🧺👩‍🌾", state: "Assam", link: "/shg", group: "SHG"  },
    { label: "Bihar महिला जीविका समूह", emoji: "🌾👩‍👩‍👧‍👧", state: "Bihar", link: "/shg", group: "SHG"  },
    { label: "Delhi NCR Mahila SHG Network", emoji: "🏙️👩‍💼", state: "Delhi", link: "/shg", group: "SHG"  },
    { label: "Gujarat મહિલા બચત મંડળ", emoji: "👩‍🧵💎", state: "Gujarat", link: "/shg", group: "SHG"  },
    { label: "Chattisgarh-MP-UP महिला स्वसहायता समूह", emoji: "👩‍🌾💪", state: "UP-MP-Chhatisgarh", link: "/shg", group: "SHG"  },
    { label: "Jharkhand सखी मंडल", emoji: "👭🌾", state: "Jharkhand", link: "/shg", group: "SHG"  },
    { label: "Karnataka ಮಹಿಳಾ ಸ್ವಸಹಾಯ ಸಂಘ", emoji: "👩‍🎓🧵", state: "Karnataka", link: "/shg", group: "SHG"  },
    { label: "Kerala കുടുംബശ്രീ സംഘം", emoji: "🌿👩‍🌾", state: "Kerala", link: "/shg", group: "SHG"  },
    { label: "Maharashtra महिला बचत गट", emoji: "👩‍👩‍👧‍👧💰", state: "Maharashtra", link: "/shg", group: "SHG" },
    { label: "Manipur মহিলা হেল্প গ্ৰুপ", emoji: "🌸🧶", state: "Manipur", link: "/shg", group: "SHG"  },
    { label: "Meghalaya Ka Seng Longkmie", emoji: "🌺👩‍🌾", state: "Meghalaya", link: "/shg", group: "SHG"  },
    { label: "Odisha ମହିଳା ସ୍ୱୟଂ ସାହାୟତା ଗୋଷ୍ଠୀ", emoji: "🪔🌾", state: "Odisha", link: "/shg", group: "SHG"  },
    { label: "Punjab ਮਹਿਲਾ ਸਵੈ ਸਹਾਇਤਾ ਸਮੂਹ", emoji: "👩‍🌾🪔", state: "Punjab", link: "/shg", group: "SHG"  },   
    { label: "Rajasthan-Haryana महिला स्वयं सहायता समूह", emoji: "🪔👩‍🌾", state: "Rajasthan-Haryana", link: "/shg", group: "SHG"  },
    { label: "Tamil Nadu பெண்கள் சுய உதவி குழுக்கள்", emoji: "🌸👩‍🏭", state: "Tamil Nadu", link: "/shg", group: "SHG"  },
    { label: "Telangana మహిళా స్త్రీ శక్తి సమూహం", emoji: "💫👩‍🌾", state: "Telangana", link: "/shg", group: "SHG"  },
    { label: "West Bengal মহিলা স্বনির্ভর গোষ্ঠী (Mahila Swanirbhar Gosthi)", emoji: "🧶👩‍🌾", state: "West Bengal", link: "/shg", group: "SHG"  },

    // 🛠️ Maharashtra Rozgar Hami
    { label: "Mahila Rozgar Hami", emoji: "💼📢", link: "/rozgarhami", group: "Maharashtra Rozgar Hami" },

    // 🤝 COMMUNITY & SOCIAL
    { label: "SAKSHAM Shakti Events", emoji: "📅🎉", link: "/event-flow-home", group: "Community & Social" },
    { label: "Applause", emoji: "👏", link: "/applause-hub-home", group: "Community & Social" },
    { label: "Green Shakti", emoji: "🌱", link: "/coolearth-home", group: "Community & Social" },
    { label: "Responsible Indian", emoji: "🌏", link: "/rim", group: "Community & Social" },
    { label: "Community Jugaad / Hack", emoji: "🧱👥", link: "/jugaad", group: "Community & Social" },
    { label: "Shakti Presentation", emoji: "📊", link: "/visualbrief-home", group: "Community & Social" },
    { label: "Shakti Forum", emoji: "🗣️", link: "/povify-home", group: "Community & Social" },
    { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "Community & Social" },
    { label: "Shakti2Farmers", emoji: "👩‍🌾", link: "/mykisan", group: "Community & Social" },

    // 🏅 RECOGNITION & PROGRESS
    { label: "Shakti Ranking", emoji: "🏆", link: "/sakshamshaktiscore", group: "Recognition & Progress" },
    { label: "Self Applause", emoji: "👏", link: "/self-applause", group: "Recognition & Progress" },
    { label: "I Was Appreciated", emoji: "👏", link: "/applause-for-me", group: "Recognition & Progress" },
    { label: "SAKSHAM Shakti Database", emoji: "🗄️", link: "/sheearnsdb", group: "Recognition & Progress" },
    { label: "Shakti Innovations", emoji: "💡", link: "/sheearns-innovationhub", group: "Recognition & Progress" },

    // 📊 ANALYTICS & INSIGHTS
    { label: "Children Study", emoji: "👧📚", link: "/bookshelf", group: "Analytics & Insights" },
    { label: "Payment Dodger DB", emoji: "📊", link: "/offboarded-home", group: "Analytics & Insights" },

    // 🎬 Wishes & Fun
    { label: "Photo Can Win", emoji: "📸", link: "/photocanwin", group: "Wishes & Fun" },
    { label: "wTube", emoji: "▶️", link: "/wtube", group: "Wishes & Fun" },
    { label: "Clap4Service", emoji: "👏", link: "/clap4service", group: "Wishes & Fun" },
    { label: "Shakti Wishes", emoji: "🌈", link: "/sheearns-wishes", group: "Wishes & Fun" },
    { label: "CarDream", emoji: "🚗", link: "/cardream", group: "Wishes & Fun" },
    { label: "Shakti Games", emoji: "🎮", link: "/sheearns-games", group: "Wishes & Fun" },
    { label: "SpotSnap", emoji: "🖼️", link: "/spotsnap", group: "Wishes & Fun" },
    { label: "Aalu Dalo Sona Nikalo", emoji: "🥔💰", link: "/aaludalosonanikalocomingsoon", group: "Wishes & Fun" },

    // 🏡 GaonSe
    { label: "GaonSe", emoji: "🏡", link: "/gaonse", group: "GaonSe" },

    // 💚 CareWorld
    { label: "CareWorld", emoji: "💚", link: "/careworld", group: "CareWorld" },
    { label: "Daily Care Log", emoji: "📝", link: "/sheearns-daily", group: "CareWorld" },
    { label: "Care Diary", emoji: "📔", link: "/mydiary-home", group: "CareWorld" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "CareWorld" },
    { label: "Daily Goal Board", emoji: "🎯", link: "/sheearns-goalboard", group: "CareWorld" },
    { label: "Daily Kanban", emoji: "📊", link: "/sheearns-kanban", group: "CareWorld" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/sheearns-touchbookplain", group: "CareWorld" },

    // 🌟 SakshamSHGProducts
    { label: "SAKSHAM SHG", emoji: "🌟", link: "/sakshamshg", group: "SAKSHAM SHG" },
    { label: "VIBHA", emoji: "🌟", link: "/sakshamshg-products", group: "SAKSHAM SHG" },
    { label: "RITU", emoji: "🌟", link: "/sakshamshg-products", group: "SAKSHAM SHG" },
    { label: "KHUSHI", emoji: "🌟", link: "/sakshamshg-products", group: "SAKSHAM SHG" },
    { label: "BABITA", emoji: "🌟", link: "/sakshamshg-products", group: "SAKSHAM SHG" },
    { label: "Gudia", emoji: "🌟", link: "/sakshamshg-products", group: "SAKSHAM SHG" },

    // 🏡 Santulit
    { label: "Santulit", emoji: "🛒", link: "/santulit", group: "Santulit Buy" },

    // 🎧 Kahani Aaj Ki
    { label: "Kahani Aaj Ki", emoji: "🎧", link: "/kahaniaajki", group: "Kahani Aaj Ki" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-pink-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-pink-400">💖 SheEarns</div>
          <div className="text-[10px] lg:text-lg text-yellow-200">
            SAKSHAM Shakti: Skilled And Keen, Systematic Homes Achieves More!
          </div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-pink-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black border-b border-pink-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                Welcome, {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-pink-900/40 text-white text-xs sm:text-sm py-2 mt-2">
        <div className="mx-auto px-2 flex flex-wrap justify-center gap-1 text-xs lg:text-m">
          <a href="/sheearns-insights" className="hover:text-yellow-200">💭 About</a>
          <a href="/rim" className="hover:text-yellow-300">🌏 RIM</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ Short News</Link>
          <a href="/sheearns-updates" className="hover:text-yellow-200">📊 Updates</a>
          <a href="/sheearns-faq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
        <div className="text-xs lg:text-m text-center my-1 mx-1 mt-2  text-pink-200/90">
           Extending Digital Empowerment for Indian Women to Support Continuous Income, Learning & Productivity!
        </div>
        <div className="mt-3 flex flex-wrap justify-center gap-3 text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-xs lg:text-m">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>        
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-pink-700">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-1 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-purple-700 text-yellow-200 shadow-md"
                  : "bg-pink-800 text-pink-100 hover:bg-pink-900"
              }`}
            >
              <span className="text-xl">{group.emoji}</span>
              <span className="mt-1 text-sm lg:text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-6 text-center text-pink-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-sm lg:text-m font-medium transition bg-transparent hover:bg-pink-700 hover:text-yellow-200 text-pink-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xl lg:text-xl">{btn.emoji}</span>
                <span className="mt-1 text-sm lg:text-m">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-pink-800 text-pink-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default SheEarnsHome;


    // { label: "महिला बचत गट (Mahila Bachat Gat)", emoji: "👩‍👩‍👧‍👧💰", state: "Maharashtra", link: "/shg", group: "Swayam Sahayata" },
    // { label: "મહિલા બચત મંડળ (Mahila Bachat Mandal)", emoji: "👩‍🧵💎", state: "Gujarat", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "महिला स्वसहायता समूह (Mahila SwaSahayata Samuh)", emoji: "👩‍🌾💪", state: "UP-MP-Chhatisgarh", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "महिला स्वयं सहायता समूह (Mahila Swayam Sahayata Samuh)", emoji: "🪔👩‍🌾", state: "Rajasthan-Haryana", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "महिला जीविका समूह (Jeevika Group)", emoji: "🌾👩‍👩‍👧‍👧", state: "Bihar", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "মহিলা স্বনির্ভর গোষ্ঠী (Mahila Swanirbhar Gosthi)", emoji: "🧶👩‍🌾", state: "West Bengal", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "ମହିଳା ସ୍ୱୟଂ ସାହାୟତା ଗୋଷ୍ଠୀ (Mahila Swayam Sahayata Gosthi)", emoji: "🪔🌾", state: "Odisha", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "பெண்கள் சுய உதவி குழுக்கள் (Pengal Suy Udhavi Kuzhukkal)", emoji: "🌸👩‍🏭", state: "Tamil Nadu", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "കുടുംബശ്രീ സംഘം (Kudumbashree Sangham)", emoji: "🌿👩‍🌾", state: "Kerala", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "ಮಹಿಳಾ ಸ್ವಸಹಾಯ ಸಂಘ (Mahila SwaSahaya Sangha)", emoji: "👩‍🎓🧵", state: "Karnataka", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "మహిళా స్వయం సహాయక బృందం (Mahila Swayam Sahayaka Brundam)", emoji: "💃🌾", state: "Andhra Pradesh", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "మహిళా స్త్రీ శక్తి సమూహం (Mahila Stree Shakti Samuham)", emoji: "💫👩‍🌾", state: "Telangana", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "सखी मंडल (Sakhi Mandal)", emoji: "👭🌾", state: "Jharkhand", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "মহিলা স্বনির্ভৰ গোট (Mahila Swanirbhar Got)", emoji: "🧺👩‍🌾", state: "Assam", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "Ka Seng Longkmie (Women’s Self Help Group)", emoji: "🌺👩‍🌾", state: "Meghalaya", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "মহিলা হেল্প গ্ৰুপ (Mahila Help Group)", emoji: "🌸🧶", state: "Manipur", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "ਮਹਿਲਾ ਸਵੈ ਸਹਾਇਤਾ ਸਮੂਹ (Mahila Swayam Sahayata Samuh)", emoji: "👩‍🌾🪔", state: "Punjab", link: "/shg", group: "Swayam Sahayata"  },
    // { label: "Mahila SHG Network (Delhi NCR)", emoji: "🏙️👩‍💼", state: "Delhi", link: "/shg", group: "Swayam Sahayata"  },